module.exports = __webpack_public_path__ + "static/img/t58.050747c4.png";